import {
  REFILL_CREDITS_URL,
  GENERAL_UPGRADE_POPUP_TYPE,
  UPGRADE_POPUP_OPENER_REF
} from 'consts'
import { useSelector } from 'react-redux'
import { userSelectors } from 'store/features/user/selectors'
import { FREE_PLAN_ID, LITE_PLAN_ID } from 'consts/user'
import { openPricingCardsPopup } from 'utils/pricingCardsPopup'

interface IOpenUpgradePopupProps {
  ref: string
  /** Per-click type, for callers whose context varies between clicks. */
  type?: string
}

interface IUseOpenUpgradePopupOptions {
  usePlanCheck?: boolean
  /**
   * Upgrade popup type, which selects the popup's headline. Defaults to the
   * generic one — credit and refill flows are generic upgrades — so only
   * callers with a specific context (TTS credits, premium voices) pass it.
   */
  type?: string
}

export const useOpenUpgradePopup = (options?: IUseOpenUpgradePopupOptions) => {
  const isFreeUser = useSelector(userSelectors.isFreeUser)
  const userCurrentPlanId = useSelector(userSelectors.userCurrentPlanId)

  const openUpgradePopup = (
    { ref, type }: IOpenUpgradePopupProps = { ref: '' }
  ) => {
    const shouldShowUpgradePopup = options?.usePlanCheck
      ? userCurrentPlanId === FREE_PLAN_ID || userCurrentPlanId === LITE_PLAN_ID
      : isFreeUser

    if (shouldShowUpgradePopup) {
      openPricingCardsPopup({
        type: type ?? options?.type ?? GENERAL_UPGRADE_POPUP_TYPE,
        openerRef: UPGRADE_POPUP_OPENER_REF
      })
    } else {
      window.open(`${REFILL_CREDITS_URL}?ref=${ref}`, '_blank')
    }
  }

  return openUpgradePopup
}
